var _style, _path, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcono6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 689.9 563.2",
    style: {
      enableBackground: "new 0 0 689.9 563.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#B0F7D5;}\r\n\t.st1{fill:#A3DDB5;}\r\n\t.st2{fill:#36504B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M119,82.1h264c-14.8,6-113.4,47.6-152.1,159c-36.3,104.6,7.2,192.9,15,208c-42.3,0-84.7,0-127,0v-367H119z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 27.4,
    cy: 68,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 140.9,
    cy: 20.3,
    r: 20.3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 72.8,
    cy: 174.4,
    r: 27.4
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 565.1,
    cy: 450.3,
    r: 23.5
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 661,
    cy: 410.3,
    r: 28.9
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -197.1799 592.5656)",
    className: "st1",
    cx: 616.7,
    cy: 534.3,
    rx: 28.9,
    ry: 28.9
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M163.6,182.8c3.3,2.2,6.9,3.7,10.3,5.5c3.7,1.9,7.3,3.9,11,5.5c2.6,1.2,1.5,5.3-1.2,5.3h-14.9 c-8.3,0-15,6.7-15,15c0,8.1,6.5,14.8,14.6,15c1.9,6.1,7.6,10.6,14.3,10.6c7.9,0,14.3-6,14.9-13.7c11.1-5.3,18.8-16.6,18.8-29.7 c0-8-2.9-15.8-8.2-21.7c-2.8-3.2-6.2-5.6-9.9-7.6l-17.8-8.9c-1.1-0.5-1.5-1.3-1.5-2.5c0-2.1,1.9-2.8,3.8-2.8h13.9 c8.3,0,15-6.7,15-15c0-8.1-6.5-14.8-14.6-15c-1.9-6.1-7.6-10.6-14.3-10.6c-7.8,0-14.3,6-14.9,13.7c-11.2,5.1-18.9,16.5-18.9,29.6 C149,166.6,154.5,176.7,163.6,182.8L163.6,182.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285,329.1H164c-8.3,0-15,6.7-15,15s6.7,15,15,15h121c8.3,0,15-6.7,15-15S293.3,329.1,285,329.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285,389.1H164c-8.3,0-15,6.7-15,15s6.7,15,15,15h121c8.3,0,15-6.7,15-15S293.3,389.1,285,389.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281,142.1h57c8.3,0,15-6.7,15-15s-6.7-15-15-15h-57c-8.3,0-15,6.7-15,15S272.7,142.1,281,142.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M281,202.1h57c8.3,0,15-6.7,15-15c0-8.3-6.7-15-15-15h-57c-8.3,0-15,6.7-15,15 C266,195.4,272.7,202.1,281,202.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M285,269.1H164c-8.3,0-15,6.7-15,15c0,8.3,6.7,15,15,15h121c8.3,0,15-6.7,15-15 C300,275.8,293.3,269.1,285,269.1L285,269.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M469.2,276.9c8.3,0,15-6.7,15-15v-0.8c0-8.3-6.7-15-15-15s-15,6.7-15,15v0.8 C454.2,270.2,460.9,276.9,469.2,276.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M586,319.1c8.3,0,15-6.7,15-15v-16c0-4.8-2.3-9.4-6.3-12.2l-117.1-83.6c-5.2-3.7-12.2-3.7-17.5,0l-47,33.8 v-159c0-8.3-6.7-15-15-15H104c-8.3,0-15,6.7-15,15v397c0,8.3,6.7,15,15,15h234.9v16c0,8.3,6.7,15,15,15h230.2c8.3,0,15-6.7,15-15 v-60c0-8.3-6.7-15-15-15H574v-101H586z M468.9,223l92.7,66.1H376.8L468.9,223z M543.9,319.1v101h-30v-101H543.9z M483.9,319.1v101 H454v-101H483.9z M424,319.1v101h-30v-101H424z M364,420.1h-10.1c-8.3,0-15,6.7-15,15v14H119v-367h264v165.6L343.7,276 c-3.9,2.8-6.3,7.4-6.3,12.2v16c0,8.3,6.7,15,15,15H364V420.1z M569.1,480.1H368.9v-30h200.2V480.1L569.1,480.1z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcono6);
export default __webpack_public_path__ + "static/media/icono6.6f65348618a031d15c0f0b697b57d6a8.svg";
export { ForwardRef as ReactComponent };